import { customerBaseApi } from "@/react/services/api/api";
import { KEY } from "@/react/components/table/useTableMutations";
import schema from "./schema";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { createNotifier } from "@/react/notifications";

const RING_GROUPS = "ring-groups";

const ringGroupsUrl = (pbxId) => `pbxes/${pbxId}/ring-group`;

export const ringGroupsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getRingGroups: build.query({
      query: (pbxId) => ({
        url: ringGroupsUrl(pbxId),
        method: "GET",
      }),
      transformResponse: (response) =>
        response?.map((ringGroup) => ({
          ...ringGroup,
          members: (ringGroup?.members ?? []).map((member) => ({
            ...member,
            isActive: true,
          })),
        })),
      providesTags: [RING_GROUPS],
    }),
    createRingGroups: build.mutation({
      query: ({ pbxId, ringGroupList }) => ({
        url: ringGroupsUrl(pbxId),
        method: "POST",
        body: ringGroupList,
      }),
      invalidatesTags: [RING_GROUPS],
    }),
    updateRingGroups: build.mutation({
      query: ({ pbxId, ringGroupList }) => ({
        url: ringGroupsUrl(pbxId),
        method: "PUT",
        body: ringGroupList,
      }),
      invalidatesTags: [RING_GROUPS],
    }),
    deleteRingGroups: build.mutation({
      query: ({ pbxId, ringGroupIds }) => ({
        url: ringGroupsUrl(pbxId),
        method: "DELETE",
        body: ringGroupIds,
      }),
      invalidatesTags: [RING_GROUPS],
    }),
  }),
});

export const {
  useGetRingGroupsQuery,
  useCreateRingGroupsMutation,
  useUpdateRingGroupsMutation,
  useDeleteRingGroupsMutation,
} = ringGroupsApi;

export const handleCreateResponse = ({
  rowsToCreate,
  setRowsToCreate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToCreate,
    setRows: setRowsToCreate,
    setData,
    responseMappingKey: schema.fields.name.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("create", "ring group"),
  });

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: schema.fields.name.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("update", "ring group"),
  });

export const handleDeleteResponse = ({
  rowsToDelete,
  setRowsToDelete,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToDelete,
    setRows: setRowsToDelete,
    setData,
    responseMappingKey: schema.fields.name.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("delete", "ring group"),
    isVoidResponse: true,
  });
